import mapActions from './mapActions';

export default mapActions('building_issue_records', {
    fetchAll_url: data => `/api/building_issues/${data.issue_id}/records`
});